import { render, staticRenderFns } from "./SituacionLaboralDelete.vue?vue&type=template&id=524939e0"
import script from "./SituacionLaboralDelete.vue?vue&type=script&lang=js"
export * from "./SituacionLaboralDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports